import { combineReducers } from 'redux'

import App from './Reducers/App'

export default combineReducers({
	App,
});